import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { SearchYourDraftFields } from '../../../features/feature-manage-drafts/models/md-search-your-draft.interface'
import { SPOrderOptionKeyEnum } from '../../../features/feature-search-projects/models/sp-order-option.interface'
import { SearchProjectResult } from '../../../features/feature-search-projects/models/sp-result.interface'
import { BasicRequest } from '../../models/interfaces/basic-request.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'

export const searchYourDraft = createAction('[manage-your-draft] Searching your draft', props<{ request: BasicRequest<SearchYourDraftFields> }>())

export const searchYourDraftSuccess = createAction(
   '[manage-your-draft] Searching your draft SUCCESS',
   props<{ result: BasicResult<SearchProjectResult[], BasicRequest<SearchYourDraftFields>> }>()
)

export const searchYourDraftFailure = createAction('[manage-your-draft] Searching your draft FAILURE', props<{ error: HttpErrorResponse }>())

export const setActualPageYourDraft = createAction('[manage-your-draft] Setting your draft actual page', props<{ page: number }>())

export const setActualOrderYourDraft = createAction('[manage-your-draft] Setting your draft actual order', props<{ order: SPOrderOptionKeyEnum }>())

export const setSearchRequestYourDraft = createAction(
   '[manage-your-draft] Setting your draft search request',
   props<{ request: BasicRequest<SearchYourDraftFields> }>()
)

export const initManageYourDraftSearch = createAction('[manage-your-draft] Init your draft search')

export const setItemForPageYourDraft = createAction('[manage-your-draft] Setting your draft item for page order', props<{ itemForPage: number }>())

export const getNumberOfYourDrafts = createAction('[manage-your-draft] Get number of your drafts')

export const getNumberOfYourDraftsSuccess = createAction('[manage-your-draft] Get number of your drafts SUCCESS', props<{ count: number }>())

export const getNumberOfYourDraftsFailure = createAction('[manage-your-draft] Get number of your drafts FAILURE', props<{ error: HttpErrorResponse }>())
